// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-comment-input[data-v-32c5e302] {\n  position: absolute;\n  z-index: 90;\n}\n.floating-comment-input .label-input[data-v-32c5e302], .floating-comment-input .comment-input[data-v-32c5e302] {\n  pointer-events: all;\n  cursor: pointer;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
